import { t } from "i18next";
import { useAppStore } from "../../../../../stores/RootStore";
import { Tab } from "../../../../../stores/TabsStore";
import { ScrollArea } from "../../../../../ui/ScrollArea/ScrollArea";
import { EquipmentLoaded } from "./EquipmentLoaded";
import { LoadBarChart } from "./LoadBarChart";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../../../../ui/Tabs/Tabs";
import { Separator } from "../../../../../ui/Separator";
import { EquipmentDay } from "./EquipmentDay";
import EHeatMap from "./EHeatMap";
import EGantt from "./EGantt";
import { useEffect, useState } from "react";
import { Losses } from "./Losses";
import { useFetch } from "@/hooks/useFetch";
import { Equipment } from "@/types/types";

export function TemplateItem({tab}:{tab: Tab}) {
  const [loading, setLoading] = useState(true)
  const {equipments} = useAppStore()
  const [currentItem, setCurrentItem] = useState(equipments?.find(e => e.id === tab.reportOptions.items[0]))
  const [itemData, setItemData] = useState(tab.options?.reportData.filter(r => r.equipment.id === tab.reportOptions.items[0]))

  const [{ response: sensorsResponse, isLoading: sensorsLoading, error: sensorsError }, doFetchItemSensors] = useFetch(`/directories/equipment_items/${currentItem?.id}/sensors`);

  useEffect(() => {
    setLoading(true)
    setCurrentItem(equipments?.find(e => e.id === tab.reportOptions.items[0]))
    setItemData(tab.options?.reportData.filter(r => r.equipment.id === tab.reportOptions.items[0]))
    doFetchItemSensors()
  }, [tab.reportOptions.items[0]])

  useEffect(() => {
    if (!sensorsResponse) {
      return;
    }
    let sensors = sensorsResponse?.data
    setCurrentItem({...currentItem, sensors: sensors} as unknown as Equipment);
    setLoading(false)
  }, [itemData, sensorsResponse])

  return (
    <div className="flex flex-col w-full h-full overflow-hidden">
      <div className="flex flex-none w-full h-24 text-base gap-2 items-center justify-between px-6">
        <div className="flex flex-col space-y-1">
          <span className="text-2xl font-semibold">{currentItem?.attributes.name}</span>
        </div>
      </div>
      
      <Separator />
      {loading ? <></> :
      <Tabs defaultValue={"common"} className="flex flex-col bg-background relative h-full w-full overflow-hidden">
        <TabsList className="flex-none h-12 w-full px-6 justify-start gap-2">
          <TabsTrigger className="data-[state=active]:bg-primary data-[state=active]:text-white" value="common">
            {t("common_info")}
          </TabsTrigger>
          <TabsTrigger className="data-[state=active]:bg-primary data-[state=active]:text-white" value="heatmap">
            {t("heatmap")}
          </TabsTrigger>
          <TabsTrigger className="data-[state=active]:bg-primary data-[state=active]:text-white" value="losses">
            {t("losses")}
          </TabsTrigger>
          <TabsTrigger className="data-[state=active]:bg-primary data-[state=active]:text-white" value="violations">
            {t("violations")}
          </TabsTrigger>
        </TabsList>
        <Separator />
        <div className="flex flex-col w-full h-full justify-start relative overflow-hidden">
          <TabsContent className="flex flex-col min-w-[1008px] w-full data-[state=active]:h-full m-0" value="common">
          <ScrollArea>
            <div className="flex flex-col gap-2">
              <div className="px-6">
                <EquipmentLoaded equipment={currentItem!} data={itemData!}/>
              </div>
              <div className="px-6 space-y-2">
                <LoadBarChart data={itemData!}/>
              </div>
              <div className="px-6 h-full">
                <EquipmentDay equipment={currentItem!} data={itemData!} />
              </div>
            </div>
          </ScrollArea>
          </TabsContent>
          <TabsContent className="flex flex-col w-full min-w-[808px] data-[state=active]:h-full m-0" value="heatmap">
            <ScrollArea>
              <div className="px-6 space-y-4 py-4">
                <div>{t('event_map')}</div>
                <EGantt data={itemData!}/>
                <div>{t('heat_map')}</div>
                <EHeatMap data={itemData!}/>
              </div>
            </ScrollArea>
          </TabsContent>
          <TabsContent className="flex flex-col w-full min-w-[808px] data-[state=active]:h-full m-0" value="losses">
            <ScrollArea>
              <div className="px-6 space-y-2">
                <Losses data={itemData!} tab={tab} />
              </div>
            </ScrollArea>
          </TabsContent>
        </div>
      </Tabs>}

    </div>
  )
}